import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center gap-1.5 text-xs text-foreground-500 py-3 px-4 md:px-6">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <span key={index} className="flex items-center gap-1.5">
            {index > 0 && (
              <div className="w-3 h-3 flex items-center justify-center">
                <i className="ri-arrow-right-s-line text-foreground-400"></i>
              </div>
            )}
            {isLast ? (
              <span className="text-foreground-700 font-medium">{item.label}</span>
            ) : item.path ? (
              <Link to={item.path} className="hover:text-primary-500 transition-colors">
                {item.label}
              </Link>
            ) : (
              <span>{item.label}</span>
            )}
          </span>
        );
      })}
    </nav>
  );
}